




















































































import { Component, Vue } from "vue-property-decorator";
import messageModule from "@/store/modules/message-module";

@Component({})
export default class GlobalMessageUI extends Vue {
  get toasts() {
    return messageModule.toasts;
  }

  get alert() {
    return messageModule.alert;
  }

  get confirm() {
    return messageModule.confirm;
  }

  get isConfirm() {
    return this.confirm.show;
  }

  get dialogVisible() {
    return this.alert.show || this.confirm.show;
  }

  set dialogVisible(val: boolean) {
    if (!val) {
      if (this.isConfirm) messageModule.resolveConfirm(false);
      else messageModule.closeAlert();
    }
  }

  get activeDialog() {
    return this.isConfirm ? this.confirm : this.alert;
  }

  public removeToast(id: number) {
    messageModule.REMOVE_TOAST(id);
  }

  public closeAlert() {
    messageModule.closeAlert();
  }

  public resolveConfirm(res: boolean) {
    messageModule.resolveConfirm(res);
  }

  public getIcon(type: string) {
    switch (type) {
      case "success":
        return "mdi-check-circle";
      case "error":
        return "mdi-alert-circle";
      case "warning":
        return "mdi-alert";
      case "info":
        return "mdi-information";
      case "question":
        return "mdi-help-circle";
      default:
        return "mdi-bell";
    }
  }

  public getIconColor(type: string) {
    switch (type) {
      case "success":
        return "#4CAF50";
      case "error":
        return "#FF5252";
      case "warning":
        return "#FB8C00";
      case "info":
        return "#2196F3";
      case "question":
        return "#448AFF";
      default:
        return "#519de1";
    }
  }
}
